import { Widget } from "@rjsf/utils";

import { LimitedCheckboxWidget } from "./LimitedCheckboxWidget";
import { TitleWidget } from "./TitleWidget";
import { ParagraphWidget } from "./ParagraphWidget";
import { SubtitleWidget } from "./SubtitleWidget";
import { MarkdownTextWidget } from "./MarkdownTextWidget";
import { UnlimitedCheckboxWidget } from "./UnlimitedCheckboxWidget";

interface WidgetRegistry {
  [name: string]: Widget;
}

export const Widgets: WidgetRegistry = {
  limitedCheckbox: LimitedCheckboxWidget,
  title: TitleWidget,
  subtitle: SubtitleWidget,
  paragraph: ParagraphWidget,
  markdownText: MarkdownTextWidget,
  // former waitlist field type (staging only); keeps those forms rendering as a plain checkbox
  waitlistCheckbox: UnlimitedCheckboxWidget
};
